// App shell — sticky header (MainNav) above a flex-1 scrollable content
// area. Mirrors inku/frontend/web/app/[locale]/(protected)/layout.tsx.

import type { ReactNode } from "react";

import { MainNav } from "./MainNav";

export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="flex h-screen flex-col bg-background">
      <MainNav />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-x-hidden overflow-y-auto">
        {children}
      </div>
    </div>
  );
}
